module.exports = __webpack_public_path__ + "static/img/guankong.f1e0aea4.png";